<template>
  <main class="success">
    <section class="wrapper section">
      <div class="success-content">
        <font-awesome-icon class="error-icon" :icon="'exclamation-triangle'" />
        <h1 class="success-title">Página não encontrada</h1>

        <p class="success-text">
          Certifique que você possui o link com o <strong>ID do programa</strong>
          para realizar seu cadastro.
        </p>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'Page404'
};
</script>
